"use client";
'use strict';

var React = require('react');
var useSafeLayoutEffect = require('./useSafeLayoutEffect.js');

/**
 * React hook to persist any value between renders,
 * but keeps it up-to-date if it changes.
 *
 * @param value the value or function to persist
 * @example
 * ```javascript
 * const fn = useCallbackRef(handler)
 * ```
 */
function useCallbackRef(fn, deps = []) {
    const ref = React.useRef(fn);
    useSafeLayoutEffect.useSafeLayoutEffect(() => {
        ref.current = fn;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return React.useCallback(((...args) => ref.current?.(...args)), deps);
}

exports.useCallbackRef = useCallbackRef;
//# sourceMappingURL=useCallbackRef.js.map
